(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-category-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function update(list) {
      var max = list.scrollWidth - list.clientWidth;
      list.classList.toggle('has-more-start', list.scrollLeft > 4);
      list.classList.toggle('has-more-end', list.scrollLeft < max - 4);
    }
    function init() {
      document.querySelectorAll('.mcs-list').forEach(function (list) {
        if (list.dataset.mcsInit) { update(list); return; }
        list.dataset.mcsInit = '1';
        list.addEventListener('scroll', function () { update(list); }, { passive: true });
        update(list);
        var active = list.querySelector('.mcs-link.is-active');
        if (active && active.offsetLeft > list.clientWidth - 60) {
          list.scrollLeft = active.offsetLeft - 16;
          update(list);
        }
      });
    }
    window.addEventListener('resize', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
